import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import FullAnalysis from "../pages/full-analysis/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/full-analysis",
    element: <FullAnalysis />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
